import { analyticsPage } from '~/utils/acquisition';

export default defineNuxtPlugin({
   name: 'segment',
   dependsOn: ['acquisition-entry'],
   setup() {
      const config = useRuntimeConfig();
      const SEGMENT_ID = typeof config.public.SEGMENT_CLIENT_ID === 'string'
         ? config.public.SEGMENT_CLIENT_ID.trim() : '';
      if (!SEGMENT_ID) return;

      const initSegment = () => {
         const analytics = (window.analytics = window.analytics || []);

         if (!analytics.initialize) {
            if (analytics.invoked) {
               console.error('Segment snippet included twice.');
               return;
            }

            analytics.invoked = true;
            analytics.methods = [
               'trackSubmit',
               'trackClick',
               'trackLink',
               'trackForm',
               'pageview',
               'identify',
               'reset',
               'group',
               'track',
               'ready',
               'alias',
               'debug',
               'page',
               'screen',
               'once',
               'off',
               'on',
               'addSourceMiddleware',
               'addIntegrationMiddleware',
               'setAnonymousId',
               'addDestinationMiddleware',
               'register',
            ];

            analytics.factory = (method) => {
               return function () {
                  if (analytics.initialized) {
                     return analytics[method].apply(analytics, arguments);
                  }

                  const args = Array.prototype.slice.call(arguments);
                  if (
                     [
                        'track',
                        'screen',
                        'alias',
                        'group',
                        'page',
                        'identify',
                     ].indexOf(method) > -1
                  ) {
                     const safePage = analyticsPage(new URL(location.href), document.referrer);
                     args.push({
                        __t: 'bpc',
                        c: safePage.url,
                        p: safePage.path,
                        u: safePage.url,
                        s: safePage.search,
                        t: document.title,
                        r: safePage.referrer,
                     });
                  }

                  args.unshift(method);
                  analytics.push(args);
                  return analytics;
               };
            };

            // Define the load function before using it
            analytics.load = function (key, options) {
               const script = document.createElement('script');
               script.type = 'text/javascript';
               script.async = true;
               // Use the config value directly here
               script.src = `https://cdn.segment.com/analytics.js/v1/${key}/analytics.min.js`;
               script.setAttribute(
                  'data-global-segment-analytics-key',
                  'analytics'
               );

               const firstScript = document.getElementsByTagName('script')[0];
               firstScript.parentNode.insertBefore(script, firstScript);
               analytics._loadOptions = options;
            };

            // Generate analytics methods
            for (let i = 0; i < analytics.methods.length; i++) {
               const method = analytics.methods[i];
               analytics[method] = analytics.factory(method);
            }

            analytics.addSourceMiddleware(({ payload, next }: {
               payload: { obj: { type?: string; context?: Record<string, unknown>; properties?: Record<string, unknown> } };
               next: (payload: unknown) => void;
            }) => {
               const safePage = analyticsPage(new URL(location.href), document.referrer);
               payload.obj.context = { ...payload.obj.context, page: safePage };
               if (payload.obj.type === 'page') {
                  payload.obj.properties = { ...payload.obj.properties, ...safePage };
               }
               next(payload);
            });

            analytics._writeKey = SEGMENT_ID;
            analytics.SNIPPET_VERSION = '5.2.0';

            // Use the config value here
            analytics.load(SEGMENT_ID);

            // Add a check to ensure the page call happens after load
            setTimeout(() => {
               analytics.page(analyticsPage(new URL(location.href), document.referrer));
            }, 100);
         }
      };

      // Only run on client-side
      if (process.client) {
         // Wrap in setTimeout to ensure DOM is ready
         setTimeout(initSegment, 0);
      }
   },
});
